import { BlocksIconSuccess } from 'blocks-nextjs/blocks-web-components/components/icon/icons/success';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconSuccess = createComponent({ react: React, tagName: 'cat-icon-success', elementClass: BlocksIconSuccess });
